//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import QBtn from 'quasar/src/components/btn/QBtn.js';;
import { HelpPanel } from '@giscube/geoportal';
export default {
  extends: HelpPanel,
  components: {
    QBtn: QBtn
  }
};